import { VenueFilterData, VenueSortData } from '../dto/EntityRepository';
import {
  VenueIndexListResponse,
  VenueListResponse,
  VenueResponse,
  VenueSearchResponse,
} from '../dto/ResDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';
import {
  buildVenueIndexParams,
  buildVenueListParams,
  getDefaultVenueFilterData,
  getDefaultVenueSortData,
} from '../util/venueListParams';
import { VenueIndexView } from '../enum/EnumRepository';

export const searchVenue = async (query: string): Promise<VenueSearchResponse> => {
  const params = new URLSearchParams({ query });
  return sendGetApiRequest<VenueSearchResponse>(`/api/v1/venue/search?${params.toString()}`);
};

export const getVenueList = async (
  page: number,
  size: number,
  sortData: VenueSortData = getDefaultVenueSortData(),
  filterData: VenueFilterData = getDefaultVenueFilterData(),
): Promise<VenueListResponse> => {
  const params = buildVenueListParams(
    { page, size, sortData },
    filterData,
  );
  return sendApiRequest<VenueListResponse>(
    'get',
    `/api/v1/venue/list?${params.toString()}`,
  );
};

export const getVenueIndex = async (
  sortData: VenueSortData = getDefaultVenueSortData(),
  filterData: VenueFilterData = getDefaultVenueFilterData(),
  view: VenueIndexView = VenueIndexView.ALL_VENUES,
): Promise<VenueIndexListResponse> => {
  const params = buildVenueIndexParams(sortData, filterData, view);
  return sendApiRequest<VenueIndexListResponse>(
    'get',
    `/api/v1/venue/index?${params.toString()}`,
  );
};

export const getVenue = async (venueId: string): Promise<VenueResponse> =>
  sendApiRequest<VenueResponse>('get', `/api/v1/venue/${venueId}`);
